import { inject } from 'mobx-react';
import { HeaderComponent } from './component';
export const Header = inject(({ ui, auth, router }) => ({
    user: auth.userData,
    logout: auth.logout,
    menu: ui.menu,
    navigate: router.navigate,
}))(HeaderComponent);
//# sourceMappingURL=index.js.map